import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

function Services() {
  const { t } = useLanguage();
  return (
    <section className="page-section">
      <div className="shell">
        <div className="page-heading page-heading--wide">
          <p className="eyebrow">{t.servicesPage.eyebrow}</p>
          <h1>{t.servicesPage.title}</h1>
          <p>{t.servicesPage.lead}</p>
        </div>

        <div className="service-list">
          {t.servicesPage.items.map(([title, text], index) => (
            <article key={title}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <div><h2>{title}</h2><p>{text}</p></div>
            </article>
          ))}
        </div>

        <div className="content-grid">
          <article className="content-card content-card--accent">
            <p className="eyebrow">{t.servicesPage.rates}</p>
            <h2>{t.servicesPage.ratesTitle}</h2>
            <p>{t.servicesPage.ratesText}</p>
            <Link to="/contacts" className="button button--primary">{t.servicesPage.getQuote}</Link>
          </article>

          <article className="content-card">
            <p className="eyebrow">{t.servicesPage.beforeSending}</p>
            <h2>{t.servicesPage.packingTitle}</h2>
            <ul className="check-list">
              {t.servicesPage.packing.map((item) => <li key={item}><span>✓</span>{item}</li>)}
            </ul>
          </article>
        </div>

        <div className="notice-panel">
          <div>
            <strong>{t.servicesPage.helpTitle}</strong>
            <p>{t.servicesPage.helpText}</p>
          </div>
          <Link to="/contacts" className="text-link">{t.servicesPage.contactUs}</Link>
        </div>
      </div>
    </section>
  );
}

export default Services;
